<div mat-dialog-title>{{title}}</div>

<mat-dialog-content class="message">
	{{confirmMessage}}
</mat-dialog-content>

<mat-dialog-actions>
	<button mat-stroked-button color="accent"
		(click)="close()">{{'DialogDeviceNotifyConfirmation.CancelButton'|translate}}</button>
	<button mat-raised-button color="accent"
		(click)="save()">{{'DialogDeviceNotifyConfirmation.ValidButton'|translate}}</button>
</mat-dialog-actions>